





























































































































import Table from '@/components/Table/Index.vue';
import {
  Component, Mixins,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import GeneralModule from '@/store/modules/General';
import GamesManagementModule from '@/store/modules/GamesManagement';
import { IDropDown } from '@/interface/General';
import { ISwitchGameMaintenance } from '@/interface/Mainternance';
import draggable from 'vuedraggable';
import GameModule from '@/store/modules/Game';
import GamesManagementData from '@/data/GamesManagementData';
import GamesManagementBody from '@/components/Table/GamesManagementBody.vue';
import ManageMixin from '@/mixins/Manage.vue';
import {
  IKeySort, ISort, ISortData,
} from '@/interface/GamesManagement';

@Component({
  components: {
    Table,
    draggable,
    GamesManagementBody,
  },
})
export default class GamesManagement extends Mixins(
  ToolMixin, ErrorHandleMixin, ManageMixin,
) {
  GeneralInstance = getModule(GeneralModule, this.$store);

  TableHead = [...GamesManagementData.TableHeadGamesManagement];

  GamesManagementInstance = getModule(GamesManagementModule, this.$store)

  GameInstance = getModule(GameModule, this.$store);

  selectedKeys = [
    {
      key: 'Please select',
    },
    {
      key: 'Provider',
    },
    {
      key: 'Types',
    },
  ]

  providerList: IDropDown[] = [];

  providerTagList: IDropDown = {
    text: '',
    value: '',
  };

  selectedProvider = '';

  dataTable: ISortData[] = [];

  newDataTable: ISortData[] = [];

  idx = 0;

  tagIndex = 0;

  isEditSort = false;

  isShowEditButton = false;

  isMove = false;

  created() {
    this.checkEdit();
  }

  async selectProviderKey(providerKey: IKeySort, index: number) {
    this.idx = index;
    if (this.idx) {
      const data = await this.GamesManagementInstance.FetchGameKey(providerKey);
      const mapData = [
        { text: 'Select', value: '' },
        ...data.map((v) => ({
          text: v.text,
          value: v.product,
        })),
      ];
      this.providerList = mapData;
    }
    this.tagIndex = 0;
    this.dataTable = [];
    this.isShowEditButton = false;
    this.isEditSort = false;
    this.isMove = false;
    this.checkEdit();
  }

  async checkEdit() {
    if (!this.isEditSort) {
      this.TableHead[0] = [...GamesManagementData.TableHeadGamesManagement[0]];
    } else {
      this.TableHead[0] = [...GamesManagementData.TableHeadEditSort[0]];
    }
  }

  async selectProviderTag(providerTag: IDropDown, index: number) {
    this.providerTagList = providerTag;
    this.tagIndex = index;
    if (this.idx) {
      const dataSelected: ISort = {
        name: providerTag.text,
      };
      const data = this.idx === 1 ? await this.GamesManagementInstance.FetchGameSort(dataSelected)
        : await this.GamesManagementInstance.FetchGameTags(dataSelected);
      if (data.length) this.isShowEditButton = true;
      this.dataTable = data;
    }
    this.isEditSort = false;
    this.isMove = false;
    this.checkEdit();
  }

  async editSortGame() {
    this.isEditSort = !this.isEditSort;
    this.checkEdit();
  }

  async onSaveEditSort() {
    if (this.newDataTable.length) {
      const mapData = this.newDataTable.map((value: ISortData, i: number) => ({
        index: i,
        code: value.code,
        gameId: value.gameId,
        name: value.name,
        kind: value.kind,
        orientation: value.orientation,
        partner: value.partner,
        size: value.size,
        riskConfig: {
          netWin: value.riskConfig?.netWin,
          multiplier: value.riskConfig?.multiplier,
        },
        _id: value._id,
        sortweb: i + 1,
        image: value.image,
        landscapeImage: value.landscapeImage,
      }));
      const sortData = {
        lists: mapData,
        tagname: this.providerTagList.text,
      };
      const { status } = this.idx === 1
        ? await this.GamesManagementInstance.EditGameSort(sortData)
        : await this.GamesManagementInstance.EditGameTags(sortData);
      if (!status.code) {
        const dataSelected = {
          name: this.providerTagList.text,
        };
        const newDataTable = this.idx === 1
          ? await this.GamesManagementInstance.FetchGameSort(dataSelected)
          : await this.GamesManagementInstance.FetchGameTags(dataSelected);
        if (newDataTable.length) this.isShowEditButton = true;
        this.dataTable = newDataTable;
      }
      this.checkError(status);
    }
    this.isEditSort = !this.isEditSort;
    this.checkEdit();
  }

  onCancel() {
    this.isEditSort = !this.isEditSort;
    this.checkEdit();
  }

  onChangeSort(data: ISortData[]) {
    this.newDataTable = data;
    this.isMove = false;
  }

  async setMaintenance(gameId: string, isMaintenance: boolean, index: number) {
    const params: ISwitchGameMaintenance = {
      gameId,
      isMaintenance,
    };
    const { status } = await this.GameInstance.SwitchGameMaintenance(params);
    if (status.code) return this.checkError(status);
    this.dataTable[index].isMaintenance = isMaintenance;
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: status.message,
      alertColor: status.code === 0 ? 'success' : 'danger',
    });
  }
}
